/**
 * @file App.jsx
 * @description Root component handling application layout and routing
 */

// Core
import React from 'react';

// Routing
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout Components
import Header from './components/Header';
import Footer from './components/Footer';
import ChatBubble from './components/ChatBubble';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Homepage from './pages/Homepage';
import OurApproach from './pages/OurApproach';
import WorkWithUs from './pages/WorkWithUs';
import Blog from './pages/Blog';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/our-approach" element={<OurApproach />} />
          <Route path="/work-with-us" element={<WorkWithUs />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </main>
      <Footer />
      <ChatBubble />
    </Router>
  );
};

export default App;
